const PATH = 'fe.components.measure.view.cycles.cycle_notes_form';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Observation Notes'
  },
  sectionDescription: {
    key: `${PATH}.section_description`,
    defaultValue: 'Add notes for each dimension'
  },
  optional: {
    key: `${PATH}.optional`,
    defaultValue: 'Optional'
  },
  notesPlaceholder: {
    key: `${PATH}.notes_placeholder`,
    defaultValue: 'Enter notes for this dimension'
  }
};

export default messages;
